import React, { Fragment, useEffect, useRef } from "react";

import Above from "core-web/components/Breakpoints/Above";
import Below from "core-web/components/Breakpoints/Below";
import PaginationThumbnail from "./PaginationThumbnail";
import PropTypes from "prop-types";
import Row from "theme/layouts/Row";
import ScrollableBox from "core-web/components/ScrollableBox";
import styled from "theme/libs/styled";

const Wrapper = styled("div")`
    position: absolute;
    bottom: 24px;
    left: 24px;
    right: 24px;
`;

const SliderItem = styled("div")`
    height: 4px;
    width: 20px;
    border-radius: 4px;
    background: ${({ theme }) => theme.colors.black};
    transition: opacity ${({ theme }) => theme.transitions.primary};

    &[data-is-active="false"] {
        opacity: 0.1;
    }
`;

const ThumbnailWrapper = ({ isThumbnailActive, slideTo, medias, activeIndex }) => {
    const slider = useRef(null);
    const isSliding = useRef(false);
    const lastMedias = useRef(null);

    const onSwipe = ({ diffX }) => {
        slider.current.scrollLeft = slider.current.scrollLeft + diffX;
    };

    useEffect(() => {
        if (slider.current) {
            const thumbnails = slider.current.firstChild.children;
            const thumbnailWidth = thumbnails[0]?.offsetWidth;
            const sliderWidth = slider.current.offsetWidth;
            const scrollLeft = slider.current.scrollLeft;
            const newPos = activeIndex * thumbnailWidth - sliderWidth / 2 + thumbnailWidth / 2;

            if ((activeIndex + 1) * thumbnailWidth > newPos) {
                slider.current.scrollLeft = newPos;
            } else if (scrollLeft > 0 && activeIndex * thumbnailWidth < newPos) {
                slider.current.scrollLeft = newPos;
            }
        }
    }, [activeIndex]);

    useEffect(() => {
        let slideIndex;
        if (lastMedias.current) {
            for (let i = 0; i < medias.length; i++) {
                const imageExists = lastMedias.current.some((m) => m.image === medias[i].image);
                if (!imageExists && !medias[i].isPromotion) {
                    slideIndex = i;
                } else if (medias[i].trigger) {
                    slideIndex = i;
                }
            }
        } else if (medias.length > 1) {
            for (let i = 0; i < medias.length; i++) {
                if (medias[i].trigger) {
                    slideIndex = i;
                }
            }
        }

        if (slideIndex !== undefined) {
            slideTo(slideIndex);
        }

        lastMedias.current = medias;
    }, [medias, lastMedias]);

    const slideToThumbnail = (index) => {
        if (!isSliding.current) {
            slideTo(index);
        }
    };

    // Hide thumbnails if none or only one
    // if (!!medias.length <= 1) {
    //     return null;
    // }

    return (
        <Wrapper data-is-wrapper="true">
            <ScrollableBox ref={slider} scrollDirection="horizontal" onSwipe={onSwipe} display="flex">
                <Row gap={["8px", null, null, "16px"]} justifyContent={["center", null, null, "start"]}>
                    {medias.map((media, index) => {
                        const isActive = isThumbnailActive(index, 1, medias.length);

                        return (
                            <Fragment key={media.key}>
                                <Below
                                    breakpoint="tabletSm"
                                    render={() => (
                                        <SliderItem data-is-active={isActive} onClick={() => slideToThumbnail(index)} />
                                    )}
                                />
                                <Above
                                    breakpoint="tabletSm"
                                    render={() => (
                                        <PaginationThumbnail
                                            media={media}
                                            active={isActive}
                                            handleClick={() => slideToThumbnail(index)}
                                        />
                                    )}
                                />
                            </Fragment>
                        );
                    })}
                </Row>
            </ScrollableBox>
        </Wrapper>
    );
};

ThumbnailWrapper.propTypes = {
    activeIndex: PropTypes.number.isRequired,
    isThumbnailActive: PropTypes.func.isRequired,
    medias: PropTypes.array.isRequired,
    slideTo: PropTypes.func.isRequired,
};

export default ThumbnailWrapper;
